module.exports = __webpack_public_path__ + "static/media/4_pfp-patient-consent-form.v02.67966dc9.pdf";